// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"316":"ad2866b8","501":"bc98253f"}[chunkId] || chunkId) + "." + {"316":"83f2bbcd93d01219","501":"d13bf505216111a2","756":"aab1dded6ccca12e","839":"852c6c7e965ce7ee"}[chunkId] + ".js";
};